import React, { Fragment } from 'react';
import useSeatsSelector from '../../../../hooks/useSeatsSelector';
import TableSelectorBack from '../TableSelectorBack';
import Seat from './seat';
import Styled from './styles';

interface SeatSelectorProps {
  sector: any;
  isFullscreen: boolean;
}

const SeatSelector = ({ sector, isFullscreen }: SeatSelectorProps) => {
  const { colors, basketSize, transliterate, t, faded } = useSeatsSelector();

  return (
    <Styled.Wrapper offset={basketSize}>
      {!isFullscreen ? (
        <Fragment>
          <Styled.Back>
            <TableSelectorBack />
          </Styled.Back>
          <Styled.SectorName>{transliterate(sector.label)}</Styled.SectorName>
        </Fragment>
      ) : null}

      <Styled.RowsTable>
        {sector.data.rows.map((label, index) => {
          const tickets = sector.data.tickets[label];

          return (
            // eslint-disable-next-line
            <Styled.Row key={index}>
              <td>
                <Styled.RowLabel>
                  {t('row')} {transliterate(label)}
                </Styled.RowLabel>
              </td>
              <td>
                <Styled.Seats>
                  {tickets
                    .sort((a, b) => a.seat - b.seat)
                    .map((ticket, seatIndex) => (
                      <Seat
                        // eslint-disable-next-line
                        key={seatIndex}
                        ticket={ticket}
                        colors={colors}
                        fade={faded(ticket.price)}
                      />
                    ))}
                </Styled.Seats>
              </td>
            </Styled.Row>
          );
        })}
      </Styled.RowsTable>
    </Styled.Wrapper>
  );
};

export default SeatSelector;
